// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { LinkActions, LinkActionTypes } from '../_actions/link.actions';
// Models
import { Link } from '../_models/link.model';
import { QueryParamsModel } from '../../_base/crud';

// tslint:disable-next-line:no-empty-interface
export interface LinksState extends EntityState<Link> {
  links: Link[];
  totalCount: number;
  error: any;
  latestSuccessfullAction: any;
  listLoading: boolean;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Link> = createEntityAdapter<Link>();

export const initialLinksState: LinksState = adapter.getInitialState({
  links: [],
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  listLoading: false,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
});

export function linksReducer(state = initialLinksState, action: LinkActions): LinksState {
  switch (action.type) {
    case LinkActionTypes.LinksPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
      };
    case LinkActionTypes.LinksPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case LinkActionTypes.LinksPageLoaded: {
      return adapter.addMany(action.payload.links, {
        ...initialLinksState,
        totalCount: action.payload.totalCount,
        showInitWaitingMessage: false,
        lastQuery: action.payload.page,
        latestSuccessfullAction: state.latestSuccessfullAction,
        links: state.links,
        error: null,
      });
    }
    case LinkActionTypes.LinksLoaded:
      return {
        ...state,
        links: action.payload.links,
      };
    case LinkActionTypes.ThrowLinkError: {
      return {
        ...state,
        error: action.payload.error,
      };
    }
    case LinkActionTypes.FireLinkSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getLinkState = createFeatureSelector<LinksState>('links');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
